module.exports = __webpack_public_path__ + "static/media/Margarita V.ed5722b4.png";